import React, { useState } from 'react';
import { PageInteractionsPrintPageForm, PagePrintTreeForm } from './PageInteractionsPrintPageForm';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { Icons } from '../../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

export function PageInteractionsPrintButton({ printTree }: { printTree: PagePrintTreeForm }) {
  const { t } = useSonTranslation('PageInteractions');
  const title = t(`print.buttonTitleText`);
  const { headMetaInfo } = useAppContext();
  const [openPrintPageModal, setOpenPrintPageModal] = useState<boolean>(false);

  // only published pages are considered in the /baumdruck/ print version
  // so if a user is on a non published page we open the browser default print mode
  const printableWithForm = headMetaInfo.versionState === 'published';

  return (
    <>
      <div className="page-interactions__button-container">
        <ButtonMinorAction
          text={title}
          icon={Icons.PRINTER}
          onClick={() => {
            if (printableWithForm) {
              setOpenPrintPageModal(true);
            } else {
              window.print();
            }
          }}
          tooltipPlacement={TooltipPlacement.TOP}
        />
      </div>
      {openPrintPageModal && (
        <PageInteractionsPrintPageForm closeModal={() => setOpenPrintPageModal(false)} printTree={printTree} />
      )}
    </>
  );
}
